const STATUS_FAILED = 'Failed';
const STATUS_UPLOADED = 'Uploaded';
const STATUS_UPLOADING = 'Uploading';

export {
    STATUS_FAILED,
    STATUS_UPLOADED,
    STATUS_UPLOADING
};